import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { EstadoTransaccion } from 'src/app/core/enum/global.enum';
import { PaginacionInterface } from 'src/app/core/models/global.model';
import { GuardService } from 'src/app/core/services/guards.service';
import { globalConfig } from 'src/app/core/utils/globalConfig';
import { construirUrl } from 'src/app/core/utils/globalFunctions';
import { FormasPagoService } from '../formas-pago/formas-pago.service';

@Injectable({
  providedIn: 'root',
})
export class TransaccionService {
  http = inject(HttpClient);
  guardService = inject(GuardService);
  location = inject(Location);
  formasPagoService = inject(FormasPagoService);


  #stateTransacciones = signal<any>({
    listado: [],
    paginacion: {},
    loading: true,
  });

  #stateTransaccionesPlacetoPay = signal<any>({
    listado: [],
    paginacion: {},
    loading: true,
  });

  #statePaso = signal<any>({
    data: {},
    loading: true,
  });

  #stateAjuste = signal<any>({
    data: {},
    loading: true,
  });

  #statePlaceToPay = signal<any>({
    data: {},
    loading: true,
  });

  #stateTipoTransacciones = signal<any>({
    data: [],
    loading: true,
  });

  #stateDiaConMasConsumo = signal<any>({
    data: {},
  });

  #stateTotalConsumoRecarga = signal<any>({
    data: {},
  });

  #stateEstaciones = signal<any>({
    data: [],
    loading: true,
  });

  public stateTransaccionesData = computed(() => this.#stateTransacciones());
  public stateTransaccionesPlacetoPayData = computed(() => this.#stateTransaccionesPlacetoPay());
  public statePasoData = computed(() => this.#statePaso());
  public stateAjusteData = computed(() => this.#stateAjuste());
  public statePlaceToPayData = computed(() => this.#statePlaceToPay());
  public stateTipoTransacciones = computed(() => this.#stateTipoTransacciones());
  public stateDiaConMasConsumoData = computed(() => this.#stateDiaConMasConsumo());
  public stateTotalConsumoRecargaData = computed(() => this.#stateTotalConsumoRecarga().data);
  public stateEstacionesData = computed(() => this.#stateEstaciones());

  getListadoTransacciones(paginacion?: PaginacionInterface, where?: any, orderBy?: any) {
    const url = construirUrl('/transaccion', paginacion, where, orderBy);
    return this.http.get(url).subscribe(({ data: { dataList, ...paginacion } }: any) => {
      this.#stateTransacciones.set({
        listado: dataList,
        paginacion: paginacion,
        loading: false,
      });
    });
  }

  getAllPeajes() {
    return this.http.get('/peaje').subscribe(({ data }: any) => {
      this.#stateEstaciones.set({
        data: data.map((peaje: any) => {
          return {
            label: peaje.nombre,
            value: peaje.codigo,
          };
        }),
        loading: false,
      });
    });
  }

  getTipoTransacciones() {
    return this.http
      .get('/transaccion/tipo-transacciones')
      .pipe(
        map(({ data }: any) => {
          return data.map((tipoTransaccion: any) => {
            return {
              code: tipoTransaccion.id,
              name: tipoTransaccion.nombre,
              tipo: tipoTransaccion.tipo,
            };
          });
        }),
      )
      .subscribe((data) => {
        this.#stateTipoTransacciones.set({
          data,
          loading: false,
        });
      });
  }
  ///transaccion/total-consumo-recarga

  getDiaConMasConsumo() {
    return this.http.get('/transaccion/dia-mayor-transaccion/data').subscribe(({ data }: any) => {
      this.#stateDiaConMasConsumo.set({
        data,
      });
    });
  }

  getTotalConsumoRecarga() {
    return this.http.get('/transaccion/total-consumo-recarga');
  }

  getTotalConsumoVehiculos() {
    return this.http.get('/transaccion/total-consumo-vehiculos');
  }

  getListadoTransaccionesMongo(status?: EstadoTransaccion, limit?: number) {
    return this.http
      .get(`/place-to-pay/get-by-numero-cliente/${status}/${limit}`)
      .subscribe(({ data: { dataList, ...paginacion } }: any) => {
        this.#stateTransaccionesPlacetoPay.set({
          listado: dataList,
          paginacion: paginacion,
          loading: false,
        });
      });
  }

  getPasoByCodigoPaso(codigoPaso: string) {
    return this.http.get(`/paso/codigo-paso/${codigoPaso}`).subscribe(({ data }: any) => {
      this.#statePaso.set({
        data,
        loading: false,
      });
    });
  }


  /*
    Recibe el request id y el codigo de referencia
  */
  getPasoByRequestId(requestId: string) {
    const requestIdLocal = sessionStorage.getItem(globalConfig.requesId);
    let url = `/place-to-pay/${requestId}`;
    if(requestId.includes('-') && requestIdLocal){
      const [tipoSesion, ,] = requestId.split('-');
      url = `/place-to-pay/${tipoSesion}-${requestIdLocal}/${requestId}`;
    }
    return this.http.get(url).subscribe(({ data }: any) => {
      // se verifica si el cuenta es un objeto
      if(typeof data?.cuenta === 'object'){
        // se actualiza los datos del signal del usuario
        this.guardService.setUserData(data.cuenta, data?.cuenta?.usuarioFront);
        // se actualiza los datos de la lista dependiendo de la ruta
        const path = this.location.path();
        if (path.includes('dashboard') || path.includes('formas-pago')) {
          this.getListadoTransaccionesMongo(EstadoTransaccion.PENDING, 1);
          this.getListadoTransacciones({ limit: 5, page: 1 });
        }
      }
      data = data?.sessionPlaceToPayDetail ?? data;
      this.#statePlaceToPay.set({
        data,
        loading: false,
      });

      if (data?.paso?.codigoPaso) {
        this.#statePaso.set({
          data: data.paso,
          loading: false,
        });
      }
      // Eliminar el requestId local
      sessionStorage.removeItem(globalConfig.requesId);
      this.formasPagoService.getMedioPagoByCuentaId();
    });
  }

  getPasaPagaByCodigoPaso(codigoPaso: string) {
    return this.http.get(`/place-to-pay/get-data-codigo-paso/${codigoPaso}`).subscribe(({ data }: any) => {
      this.#statePlaceToPay.set({
        data,
        loading: false,
      });

      if (data?.paso?.codigoPaso) {
        this.#statePaso.set({
          data: data.paso,
          loading: false,
        });
      }
    });
  }

  getAjusteByCodigoAjuste(codigoAjuste: string) {
    return this.http.get(`/paso/ajuste-paso/${codigoAjuste}`).subscribe(({ data }: any) => {
      this.#stateAjuste.set({
        data,
        loading: false,
      });
      if (data?.paso?.codigoPaso) {
        this.#statePaso.set({
          data: data.paso,
          loading: false,
        });
      }
    });
  }

  getNotaCreditoByCodigoTransaccion(codigoTransaccion: string) {
    return this.http.get(`/transaccion/nota-debito-credito/${codigoTransaccion}`).subscribe(({ data }: any) => {
      //console.log(data);
      this.#stateAjuste.set({
        data,
        loading: false,
      });
      if (data?.paso?.codigoPaso) {
        this.#statePaso.set({
          data: data.paso,
          loading: false,
        });
      }
    });
  }

  generarReporteMovimientos(reporteTransaccion: any) {
    return this.http.post('/transaccion/generar-reporte', reporteTransaccion, {
      responseType: 'blob',
    });
  }

  clearDataTransaccion() {
    this.#statePaso.set({
      data: {},
      loading: true,
    });
    this.#stateAjuste.set({
      data: {},
      loading: true,
    });
    this.#statePlaceToPay.set({
      data: {},
      loading: true,
    });
  }
}
